import React, { Fragment, Component } from "react";
import { Route } from "react-router";
import { connect } from "react-redux";
import { Container, ListGroup, ListGroupItem } from "reactstrap";

import "../assets/styles/style";
import "../assets/styles/admin";

import Header from "../components/Header";
import Footer from "../components/Footer";
import Messages from "../components/Messages";

class Admin extends Component {
  handleChange(event) {
    window.location.replace(event.target.value);
  }

  render() {
    return (
      <Fragment>
        <Header />
        <Container>
          <Messages />
          <div className="row">
            <div className="col-md-2">
              <select className="d-block d-md-none mb-4 w-100 p-3" onChange={this.handleChange}>
                <option value="/admin">Assinatura</option>
                {this.props.subscription.data.via && this.props.subscription.data.via !== 'voucher' && (
                  <option value="/admin/payments">Pagamentos</option>
                )}
                <option value="/admin/vouchers">Vouchers</option>
                <option value="/admin/user">Meus Dados</option>
              </select>

              <div className="d-none d-md-block">
                <ListGroup flush>
                  <ListGroupItem tag="a" href="/admin">
                    Assinatura
                  </ListGroupItem>
                  {this.props.subscription.data.via && this.props.subscription.data.via !==
                    'voucher' && (
                      <ListGroupItem tag="a" href="/admin/payments">
                        Pagamentos
                      </ListGroupItem>
                    )}
                  <ListGroupItem tag="a" href="/admin/vouchers">
                    Vouchers
                  </ListGroupItem>
                  <ListGroupItem tag="a" href="/admin/user">
                    Meus Dados
                  </ListGroupItem>
                </ListGroup>
              </div>
            </div>
            <div className="col-md-10">
              <Route component={this.props.page} />
            </div>
          </div>
        </Container>

        <Footer />
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  subscription: state.subscription.subscription
});

export default connect(mapStateToProps, null)(Admin);



// WEBPACK FOOTER //
// ./src/layouts/admin.js